<template>
  <m-card-item
    icon="line-chart"
    @click="open = true"
  >
    {{ $t('goalInsightsBoundedProgressMenu.optionLabel') }}
    <template #right>
      <m-select
        v-model:open="open"
        :items="options"
        :value="bounded"
        value-key="value"
        xs
        hide-hover
        arrow-type="right"
        hide-border
        item-text="text"
        tooltip-placement="left"
        full-width
        has-tooltip
        @input="select"
      />
    </template>
  </m-card-item>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  bounded: {
    type: Boolean,
    default: true,
  },
});

const open = ref(false);

const emit = defineEmits(['input']);

const options = computed(() => [
  {
    value: true,
    text: t('goalInsightsBoundedProgressMenu.bounded'),
    tooltip: t('goalInsightsBoundedProgressMenu.boundedTooltip'),
  },
  {
    value: false,
    text: t('goalInsightsBoundedProgressMenu.unbounded'),
    tooltip: t('goalInsightsBoundedProgressMenu.unboundedTooltip'),
  },
]);

const select = (value) => {
  emit('input', value);
};
</script>

<style lang="scss" type="scss" scoped>
</style>
